module.exports = __webpack_public_path__ + "static/media/Carla.ce112643.webp";